import _ from 'lodash';
import React, { Component } from 'react';

import { TodoList } from '../shared';

import {
  getCurrentTime,
} from '../../util';

class KeyRisks extends Component {

  addKeyRisk(newRiskText){
    const updatedDeal = {
      ...this.props.deal,
      keyRisks: [
        ...(this.props.deal.keyRisks || []),
        {
          text: newRiskText,
          completed: false,
        }
      ]
    }

    this.props.updateDeal(updatedDeal, deal => {
      console.log('deal updated!');
    });
  }
  completeKeyRisk(risk){

    let risksToUpdate = this.props.deal.keyRisks;

    const riskIndex = _.indexOf(risksToUpdate, risk);

    const completedRisk = {
      ...risk,
      completed: true,
      completedOn: getCurrentTime()
    }

    risksToUpdate[riskIndex] = completedRisk;

    const updatedDeal = {
      ...this.props.deal,
      keyRisks: risksToUpdate
    }

    this.props.updateDeal(updatedDeal, deal => {
      console.log('deal updated!');
    });

  }

  uncompleteKeyRisk(risk){

    let risksToUpdate = this.props.deal.keyRisks;

    const riskIndex = _.indexOf(risksToUpdate, risk);

    const uncompletedRisk = {
      text: risk.text,
      completed: false,
    }

    risksToUpdate[riskIndex] = uncompletedRisk;

    const updatedDeal = {
      ...this.props.deal,
      keyRisks: risksToUpdate
    }

    this.props.updateDeal(updatedDeal, deal => {
      console.log('deal updated!');
    });

  }

  deleteKeyRisk(risk){
    let risksToUpdate = [ ...this.props.deal.keyRisks ];

    const riskIndex = _.indexOf(risksToUpdate, risk);

    risksToUpdate.splice(riskIndex, 1);

    const updatedDeal = {
      ...this.props.deal,
      keyRisks: risksToUpdate
    }

    this.props.updateDeal(updatedDeal, deal => {
      console.log('deal updated!');
    });
  }

  render(){
    return(
      <TodoList
        addItem={item => { this.addKeyRisk(item); }}
        completeItem={this.completeKeyRisk.bind(this)}
        uncompleteItem={this.uncompleteKeyRisk.bind(this)}
        deleteItem={this.deleteKeyRisk.bind(this)}
        className="risk-todos"
        newItemLabel={'New risk'}
        items={this.props.keyRisks}
      />
    )
  }
}

export default KeyRisks;



// WEBPACK FOOTER //
// ./src/components/deal/keyRisks.js